import { Injectable } from '@angular/core';
import { RecipeDetailsComponent } from '../../modules/recipe/recipe-details/recipe-details.component';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesService {
  public detailsComponent: RecipeDetailsComponent | null = null;
}
